import { Grid, Skeleton, Typography } from '@mui/material'
import React from 'react'
import BodyHeader from '../molecules/BodyHeader'
import TitleSubtitle from '../molecules/TitleSubtitle'
import Zone from '../organisms/Zone'
import Button from '../atoms/Button'
import useBecomeVolunteer from '../../hooks/useBecomeVolunteer'

import { ReactComponent as DownloadIcon } from '../../media/arrow_download_icon_white.svg'
import { APP_BASE_URL, CATEGORIES, CONTACT_URL, EMAIL } from '../../constants'
import usePoste from '../../hooks/usePoste'

const BecomeVolunteer = () => {
	const { isLoading, title, content } = useBecomeVolunteer()
	const { postes } = usePoste(CATEGORIES.POSTE.BENEVOLE.id)

	return (
		<>
			{(isLoading && <Skeleton />) || <BodyHeader title={title}>{content}</BodyHeader>}
			{postes && (
				<Zone color="white">
					<TitleSubtitle
						title="missions bénévoles"
						subtitle="Engagez-vous auprès de La Collecterie"
					/>

					{postes.map(({ title, type, duration, modifiedDate, src, download }, index) => (
						<Grid
							key={index}
							container
							sx={(theme) => ({
								border: 'solid 1px black',
								justifyContent: 'space-between',
								mt: 4,
								height: 148,
								'& img': {},

								[theme.breakpoints.down('md')]: {
									height: 'inherit',
									p: 2,
									textAlign: 'center',

									'& p': {
										textAlign: 'center',
									},
								},
							})}
						>
							<Grid
								item
								xs={12}
								md={1.2}
								sx={{
									height: 148,
									overflow: 'hidden',
									display: 'flex',
									justifyContent: 'left',
									'& img': {
										height: '100%',
									},
								}}
							>
								<img src={src} alt="" />
							</Grid>
							<Grid item xs={12} md={7} sx={{ pt: 3, textAlign: 'left' }}>
								<Typography sx={{ color: 'text.primary', fontWeight: 800, fontSize: 22, mb: 2 }}>
									{title}
								</Typography>
								<Typography sx={{ color: 'text.primary' }}>
									{type} | {duration} | {modifiedDate}
								</Typography>
							</Grid>
							<Grid
								item
								xs={12}
								md={2}
								sx={(theme) => ({
									pr: 6,
									pt: 2,
									[theme.breakpoints.down('md')]: {
										p: 0,
									},
								})}
							>
								<Button
									target="_blank"
									bgColor="green"
									color="white"
									label="Télécharger"
									href={download}
									endIcon={<DownloadIcon />}
									mt={4}
								/>
							</Grid>
						</Grid>
					))}
				</Zone>
			)}
			<Zone color="ivory">
				<Typography sx={{ color: 'text.primary', fontSize: 32, fontWeight: 700, mb: 2 }}>
					Aucun poste ne correspond à votre profil ?
				</Typography>
				<Typography sx={{ color: 'text.primary' }}>
					Candidatez de manière spontanée à l’adresse mail suivante
				</Typography>
				<Button
					bgColor="blue"
					color="white"
					label="Contactez l'équipe des benevoles"
					mt={4}
					href={`${APP_BASE_URL}${CONTACT_URL}/${EMAIL.BENEVOLE}`}
				/>
			</Zone>
		</>
	)
}

export default BecomeVolunteer
